import { lazy } from "react";
import RoleSwitch from "modules/swiftboard/components/RoleSwitch";

// /swiftboard/project-history — role-based page
const pages = {
  ADMIN:  lazy(() => import("./admin/AdminProjectHistory")),
  CLIENT: lazy(() => import("./client/ClientProjectHistory")),
};

export default function ProjectHistory() {
  return <RoleSwitch pages={pages} />;
}
